import { logger } from 'src/Utils/LoggerService/LoggerService';
import './Document.css';
import LineSeparation from 'src/SharedComponents/LineSeparation/LineSeparation';
interface ITechDocGrid {
    title: string;
    image?: string;
    fileLink:string;
    duration?: string;
}
const Document: React.FC<ITechDocGrid> = ({ title, image, fileLink, duration }) => {
    return (
        <div>
            <div className='me-3'>
                <div className='row d-flex mt-4 document' style={{ height: '300px' }}>
                    <div className='mx-2 my-2'>
                        <div className="m-1">
                            <span className='document-header row'>
                                <div className={`${duration ? 'col-md-10' : 'col-md-12'}`}>
                                    {title}
                                </div>
                                {duration && (
                                    <div className='extra-text-right col-2 d-flex justify-content-end'>
                                        {duration}
                                    </div>
                                )}
                            </span>
                        </div>

                        <LineSeparation />
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', height: '210px', borderRadius: '25px', marginTop: '4px' }}
                             onClick={() => { logger.logInformation(`User downloaded file with name: "${title}".`) }}>
                            <a
                                href={fileLink}
                                target="_blank"
                                rel="noOpener noReferrer"
                                style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '8px 20px 8px 8px' }}>
                                <img src={image} alt="Technical document" style={{ cursor: 'pointer', width: '100%', height: '100%', objectFit: 'cover', borderRadius: '16px' }} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Document